import { Stack, Typography } from '@mui/material';
import { ArrowRightIcon } from '@mui/x-date-pickers';
import { useNavigate } from 'react-router-dom';
import ButtonWithLoading from 'src/components/common/ButtonWithLoading';
import ImageComponent from 'src/components/common/Image';
import ModalComponent from 'src/components/Modal/ModalComponent';
import { TypeActivitiesTab } from 'src/features/Activities/config';
import { ICON_NO_DATA_COMPANY } from 'src/utils/constants/imagesUrl';
import { AuthRouteKeys } from 'src/utils/constants/routes';

const PopupLeaveCurrentPlan = ({ open, handleClose }: { open: boolean; handleClose: () => void }) => {
  const navigate = useNavigate();

  const handleGoToTeamManagement = () => {
    navigate(`${AuthRouteKeys.Activities}?tab=${TypeActivitiesTab.TEAM_MANAGEMENT}`);
    handleClose();
  };

  return (
    <ModalComponent closeOnBackdropClick padding={4} open={open} handleClose={handleClose} showCloseIcon>
      <Stack direction="column" spacing={2} width={600} alignItems="center">
        <ImageComponent imgSrc={ICON_NO_DATA_COMPANY} height={150} />
        <Typography textAlign="center" variant="h4">
          Leave Current Plan
        </Typography>
        <Typography textAlign="center" variant="body1" color="text.secondary">
          You are currently a member of a team plan. To purchase a new plan, you must first leave your current team.
        </Typography>

        <Stack direction="row" spacing={2} width="100%" justifyContent="center" mt={2}>
          <ButtonWithLoading variant="outlined" size="large" color="secondary" onClick={handleClose} fullWidth>
            Close
          </ButtonWithLoading>
          <ButtonWithLoading
            size="large"
            endIcon={<ArrowRightIcon />}
            variant="contained"
            color="primary"
            onClick={handleGoToTeamManagement}
            fullWidth
          >
            Go to Team Management
          </ButtonWithLoading>
        </Stack>
      </Stack>
    </ModalComponent>
  );
};

export default PopupLeaveCurrentPlan;
